import { useRepo } from '@/hooks/useSwr';

export interface GetLatestCommitFromHubRefResult {
  hubRefRepoName: string;
  latestCommit: string | null;
}

export function useLatestCommitFromHubRef(
  hubRef: string
): GetLatestCommitFromHubRefResult {
  const [hubRefRepoName, hubRefCommitHashOrLatest] = hubRef.split(':');

  const repo = useRepo(undefined, hubRefRepoName);
  const latestCommit =
    hubRefCommitHashOrLatest === 'latest'
      ? repo.data?.repo?.last_commit_hash ?? null
      : hubRefCommitHashOrLatest;

  return {
    hubRefRepoName,
    latestCommit,
  };
}
